import {useMutation} from "@tanstack/react-query";
import {reviewApi} from "../services/review";
import {showToastModal} from "../jsx/components/shared/ToastModalSwal";

export const useAddReview = () => {
  const {mutate: add} = useMutation({
    mutationFn: reviewApi.add,
    onSuccess: () => {
      showToastModal({
        success: true,
        title: "Succès",
        message:
          "Évaluation ajoutée avec succès. Elle va être modérée par l’équipe Help Clic. ",
        thenCallback: () => {
          showToastModal({
            title: "Intervention finalisée",
            message: "L'intervention a été finalisée avec succès.",
            success: true,
          });
        },
      });
    },
  });

  const onAddReview = ({rating, comment, interventionId, createdForId}) => {
    add({
      body: {
        rating,
        comment,
        interventionId,
        createdForId,
      },
    });
  };

  return {
    onAddReview,
  };
};
